import { computed } from "vue";
import { formatCompactNumber } from "@/src/utils/analyticsChartUtils.js";
import { apexChartTypes } from "@/src/constants/analyticConstants.js";

export const useLineAreaChartOptions = ({
  baseOptions,
  isDark,
  textColor,
  gridColor,
  labelColor,
  categories,
  xAxisLabel,
  yAxisLabel,
  getFormattedValue,
  apexType,
  decimalPlaces,
}) => {
  return computed(() => ({
    ...baseOptions.value,
    dataLabels: { enabled: false },
    markers: {
      size: 4,
      strokeWidth: 2,
      strokeColors: isDark.value ? "#1f2937" : "#ffffff",
      hover: { size: 6 },
    },
    stroke: {
      width: apexType.value === apexChartTypes.AREA ? 2 : 3,
      curve: "smooth",
      colors: baseOptions.value.colors,
    },
    fill: {
      type: apexType.value === apexChartTypes.AREA ? "gradient" : "solid",
      gradient: {
        shade: isDark.value ? "dark" : "light",
        type: "vertical",
        shadeIntensity: 0.1,
        inverseColors: isDark.value,
        opacityFrom: 0.5,
        opacityTo: 0.2,
        stops: [0, 90],
      },
    },
    xaxis: {
      categories: categories.value,
      title: {
        text: xAxisLabel.value,
        style: {
          color: labelColor,
          fontSize: "12px",
          fontFamily: "Proxima Nova, sans-serif",
          fontWeight: 500,
          cssClass: "primary_color",
        },
      },
      labels: {
        style: {
          colors: textColor,
          fontSize: "11px",
          fontFamily: "Proxima Nova, sans-serif",
        },
        rotate: -45,
        rotateAlways: categories.value.length > 6,
      },
      axisBorder: { show: true, color: gridColor },
      axisTicks: { show: false },
    },
    yaxis: {
      title: {
        text: yAxisLabel.value,
        style: {
          color: labelColor,
          fontSize: "12px",
          fontFamily: "Proxima Nova, sans-serif",
          fontWeight: 500,
          cssClass: "primary_color",
        },
      },
      labels: {
        style: {
          colors: textColor,
          fontSize: "11px",
          fontFamily: "Proxima Nova, sans-serif",
        },
        formatter: (val) => formatCompactNumber(val, decimalPlaces?.value),
      },
    },
    tooltip: {
      ...baseOptions.value.tooltip,
      y: {
        formatter: (val, opts) =>
          getFormattedValue(opts.seriesIndex, opts.dataPointIndex),
      },
    },
  }));
};

